import { connect } from "react-redux";

import Pagination from "../components/Table.Pagination.Component";

import * as tableActions from "../commands/table.actions";

function mapStateToProps(state) {
  return {
    tables: state.tables,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changePage: (page, tableKey) => {
      dispatch(tableActions.change_page(page, tableKey));
    },
    changePageSize: (size, tableKey) => {
      dispatch(tableActions.change_page_size(size, tableKey));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Pagination);
